import { inject, Injectable, signal } from '@angular/core';
import { KnowledgeStateTablesService, KnowledgeUserState, KnowledgeTrackerService } from '@dataclouder/ngx-knowledge';

@Injectable({
  providedIn: 'root',
})
export class KnowledgeWordStateService {
  public knowledgeWordStateArray = signal<KnowledgeUserState[]>([]);

  private _knowledgeWordStateDict: Record<string, Record<string, KnowledgeUserState>> = {};

  private knowledgeStateTablesService = inject(KnowledgeStateTablesService);
  private knowledgeTrackerService = inject(KnowledgeTrackerService);

  public async getKnowledgeWordStateDict(lang: string = null): Promise<Record<string, KnowledgeUserState>> {
    if (this._knowledgeWordStateDict[lang]) {
      return this._knowledgeWordStateDict[lang];
    } else {
      this._knowledgeWordStateDict[lang] = await this.knowledgeStateTablesService.getAllKnowledgeUserStateDict(`knowledgeState.${lang}.word`);
      this.knowledgeWordStateArray.set(Object.values(this._knowledgeWordStateDict[lang]));

      if (Object.keys(this._knowledgeWordStateDict[lang]).length === 0) {
        console.log('empty knowledge word state trying to get from back end');
        const res = await this.knowledgeTrackerService.getKnowledgeByPath(`${lang}.word`, `knowledgeState.${lang}.word`);
        if (res) {
          const knowledgeUserStateArray = Object.values(res);
          await this.knowledgeStateTablesService.bulkAddOrUpdateKnowledgeUserStates(`knowledgeState.${lang}.word`, knowledgeUserStateArray);
          this._knowledgeWordStateDict[lang] = await this.knowledgeStateTablesService.getAllKnowledgeUserStateDict(`knowledgeState.${lang}.word`);
          this.knowledgeWordStateArray.set(Object.values(this._knowledgeWordStateDict[lang]));
        } else {
          // No words, first time.
          this._knowledgeWordStateDict[lang] = {};
          this.knowledgeWordStateArray.set([]);
        }
      }
      return this._knowledgeWordStateDict[lang];
    }
  }

  public async getKnowledgeWordStateArray(targetLang: string): Promise<KnowledgeUserState[]> {
    return Object.values(await this.getKnowledgeWordStateDict(targetLang));
  }

  public async updateMemoryAndDB(targetLang: string, stateWords: KnowledgeUserState[]) {
    this.knowledgeStateTablesService.bulkAddOrUpdateKnowledgeUserStates(`knowledgeState.${targetLang}.word`, stateWords);
    // Check what structure and i'm using here.
    for (const word of stateWords) {
      this._knowledgeWordStateDict[targetLang][word.concept] = word;
    }
    this.knowledgeWordStateArray.set(Object.values(this._knowledgeWordStateDict[targetLang]));
  }

  public async deleteKnowledgeWordState(concept: string, targetLang: string): Promise<void> {
    // Check that is working
    this.knowledgeStateTablesService.deleteKnowledgeUserState(`knowledgeState.${targetLang}.word`, concept);
    delete this._knowledgeWordStateDict[targetLang][concept];
    this.knowledgeWordStateArray.set(Object.values(this._knowledgeWordStateDict[targetLang]));
  }

  public async clearMemoryAndDB() {
    this.knowledgeStateTablesService.clearAllData();
    this._knowledgeWordStateDict = {};
    this.knowledgeWordStateArray.set([]);
  }
}
